export const workloadIds = ['active', 'available', 'upskilling'] as const;

export const manualIds = ['onLeave'] as const;

export const ids = [...workloadIds, ...manualIds] as const;
